import { render, staticRenderFns } from "./RegisterProspectForm.vue?vue&type=template&id=4c6e0ed4"
import script from "./RegisterProspectForm.vue?vue&type=script&lang=js"
export * from "./RegisterProspectForm.vue?vue&type=script&lang=js"
import style0 from "./RegisterProspectForm.vue?vue&type=style&index=0&id=4c6e0ed4&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports